import { MarketWarningType, VaultV2WarningType, VaultWarningType } from '@/helpers/warnings'

export interface WarningScrollConfig {
  elementId: string
}

// Warning type to scroll config mapping
export const WARNING_SCROLL_CONFIG: Partial<Record<string, WarningScrollConfig>> = {
  // Vault warnings
  [VaultWarningType.SHORT_TIMELOCK]: {
    elementId: 'risk-disclosures-section'
  },
  // Vault V2 warnings
  [VaultV2WarningType.TIMELOCK]: {
    elementId: 'timelocks-section'
  },
  // Market warnings
  [MarketWarningType.BAD_DEBT_UNREALIZED]: {
    elementId: 'liquidation-section'
  },
  [MarketWarningType.ORACLE_PRICE_DERIVATION]: {
    elementId: 'oracle-section'
  }
}

export function getWarningNavigationConfig(
  warningType: string | undefined
): WarningScrollConfig | null {
  if (!warningType) return null
  return WARNING_SCROLL_CONFIG[warningType] ?? null
}
